import { NgModule } from '@angular/core';
import { CustomCurrencyPipe } from './currency-symbol.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
    imports:        [CommonModule],
    declarations:   [CustomCurrencyPipe],
    exports:        [CommonModule, CustomCurrencyPipe],
})

export class CurrencyPipeModule {

  static forRoot() {
     return {
         ngModule: CurrencyPipeModule,
         providers: [],
     };
  }
}
